import React, { createContext, useContext, useEffect, useState } from "react";

const LANGS = ["it", "en", "de", "pt", "hu"];
const DEFAULT_LANG = "it";
const STORAGE_KEY = "mama_lang";

const dict = {
  it: {
    nav: { home: "Home", menu: "Menù", reviews: "Recensioni", asporto: "Asporto", contact: "Contatti", book: "Prenota ora" },
    hero: {
      eyebrow: "Lignano Sabbiadoro",
      tagline: "Pizza a lunga lievitazione in stile napoletano — bordo alto soffice o bassa e croccante a carro di ruota. Pasta fresca fatta in casa, pesce dell'Adriatico e la vera cucina italiana a due passi dal mare.",
      bookCta: "Prenota un tavolo",
      menuCta: "Esplora il menù",
      open: "Aperti 7 giorni su 7",
    },
    about: {
      eyebrow: "La nostra storia",
      title: "La migliore pizzeria",
      subtitle: "A LIGNANO SABBIADORO",
      p1: "Se cerchi una pizzeria a Lignano Sabbiadoro dove si mangia davvero bene, sei nel posto giusto. Da mAmA la pizza è a lunga lievitazione: leggera, fragrante e altamente digeribile, stile napoletano classico a bordo alto oppure bassa e croccante a carro di ruota.",
      p2: "Accanto alla pizza, un vero ristorante italiano con pasta fresca fatta in casa, piatti tipici, specialità di carne e pesce dell'Adriatico. Farine selezionate, pomodori San Marzano DOP e mozzarella di bufala campana: l'Italia autentica a pochi passi dal mare.",
      years: "ANNI DI TRADIZIONE",
      h1_title: "Pizza a lunga lievitazione",
      h1_desc: "Stile napoletano: bordo alto soffice o bassa e croccante a carro di ruota. Leggera e digeribile.",
      h2_title: "Pasta fresca fatta in casa",
      h2_desc: "Tagliatelle, gnocchi e ravioli preparati ogni mattina. Piatti di carne e pesce dell'Adriatico.",
      h3_title: "Zero coperto, cuore aperto",
      h3_desc: "Da noi il coperto non si paga — perché a casa l'accoglienza non si mette in conto.",
    },
    noCoperto: {
      eyebrow: "DA mAmA · UNA COSA IN MENO DA PAGARE",
      title: "Niente coperto.",
      sub: "Perché a casa l'accoglienza non si fattura — e il sorriso, qui, è sempre compreso.",
    },
    menu: {
      eyebrow: "Il nostro menù",
      title: "Sapori di mAmA",
      subtitle: "CUCINA & PIZZA",
      intro: "Pizza a lunga lievitazione, pasta fresca fatta in casa, specialità di mare e carne. Il menù può variare in base alla stagione.",
      footer: "Prezzi in Euro. Per allergie e intolleranze chiedi al personale.",
      tabs: { antipasti: "Antipasti", primi: "Primi", secondi: "Secondi", insalate: "Insalatone", pizze: "Pizze", dolci: "Dolci", bevande: "Bevande" },
    },
    reviews: {
      eyebrow: "Recensioni",
      title: "Cosa dicono di noi",
      subtitle: "OSPITI · TURISTI · VICINI",
      basedOn: "basato su oltre 500 recensioni",
      outro: "Ti è piaciuta la tua esperienza?",
      leaveLink: "Lascia una recensione →",
    },
    res: {
      eyebrow: "Prenotazione",
      title: "Riserva il tuo tavolo",
      desc: "Compila il modulo per prenotare. Riceverai la conferma via email e WhatsApp. Per gruppi oltre 10 persone, contattaci direttamente.",
      info1: "Aperti 7 giorni su 7 · 11:30 – 23:00 no stop",
      info2: "Tavoli per 1 – 20 persone",
      name: "NOME E COGNOME *",
      phone: "TELEFONO *",
      email: "EMAIL (opzionale)",
      date: "DATA *",
      time: "ORA *",
      people: "NUMERO PERSONE *",
      peoplePlaceholder: "Quante persone?",
      timePlaceholder: "Seleziona orario",
      datePlaceholder: "Scegli una data",
      notes: "NOTE (allergie, occasione speciale...)",
      notesPh: "Es. tavolo all'aperto, compleanno, intolleranze...",
      submit: "Conferma prenotazione",
      submitSub: "Cliccando, verrai reindirizzato anche a WhatsApp con i dati pre-compilati.",
      policyTitle: "Importante per la tua prenotazione",
      policyBody: "Tolleriamo un ritardo massimo di 7 minuti. Il tavolo viene assegnato e confermato solo se all'orario stabilito il gruppo è al completo: se manca anche solo una persona la prenotazione decade. Sono regole necessarie per lavorare con rispetto anche degli altri ospiti che hanno prenotato e per avere il tempo di seguire con attenzione tutti i nostri clienti.",
      toastErr: "Compila tutti i campi obbligatori",
      toastOk: "Prenotazione confermata! A presto da mAmA.",
      toastFail: "Errore nell'invio. Riprova o chiamaci direttamente.",
      toastFull: "Posti esauriti per quell'orario. Scegli un altro turno.",
      toastCutoff: "Per oggi le prenotazioni online sono chiuse (dopo le 17:30) per organizzare al meglio il servizio serale. Chiamaci direttamente.",
      groupNote: "Per gruppi oltre 5 persone la prenotazione richiede una riconferma personale. Il ristorante ti contatterà a breve per confermare.",
      groupSubmit: "Invia richiesta gruppo (6+)",
      cutoffBanner: "Oggi le prenotazioni online sono chiuse dopo le 17:30, così possiamo preparare al meglio il servizio serale. Per prenotare per oggi chiamaci:",
      slotFull: "Esaurito",
      slotRemaining: "posti rimasti",
      personOne: "persona",
      personMany: "persone",
    },
    asporto: {
      eyebrow: "TAKE-AWAY",
      title: "Porta a casa il gusto.",
      desc: "Tutto il nostro menù è disponibile anche per asporto. Ordina per telefono o WhatsApp e ritira in 20 minuti. Ordini online in arrivo!",
      call: "Chiama per ordinare",
      whatsapp: "Ordina su WhatsApp",
      note: "Ordini online in arrivo a breve.",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Vieni a trovarci",
      desc: "Nel cuore di Lignano Sabbiadoro, a pochi minuti dalla spiaggia. Ti aspettiamo per un'esperienza italiana autentica.",
      address: "INDIRIZZO",
      phone: "TELEFONO",
      email: "EMAIL",
      hours: "ORARI",
      hoursDay: "Tutti i giorni",
      copyright: "Tutti i diritti riservati",
    },
    whatsappMsg: "Ciao mAmA Cucina e Pizza! Vorrei alcune informazioni.",
    whatsappAsporto: "Ciao! Vorrei fare un ordine da asporto.",
    whatsappResIntro: "Ciao mAmA Cucina e Pizza! Vorrei prenotare un tavolo:",
    whatsappResName: "Nome",
    whatsappResPhone: "Telefono",
    whatsappResDate: "Data",
    whatsappResTime: "Ora",
    whatsappResPeople: "Persone",
    whatsappResNotes: "Note",
  },

  en: {
    nav: { home: "Home", menu: "Menu", reviews: "Reviews", asporto: "Take-away", contact: "Contact", book: "Book now" },
    hero: {
      eyebrow: "Lignano Sabbiadoro",
      tagline: "Long-rising Neapolitan-style pizza — high soft crust or thin and crispy \"carro di ruota\". Homemade fresh pasta, Adriatic seafood and authentic Italian cuisine, just steps from the beach.",
      bookCta: "Book a table",
      menuCta: "Explore the menu",
      open: "Open 7 days a week",
    },
    about: {
      eyebrow: "Our story",
      title: "The best pizzeria",
      subtitle: "IN LIGNANO SABBIADORO",
      p1: "Looking for a pizzeria in Lignano Sabbiadoro where the food is truly great? You're in the right place. At mAmA our pizza is long-risen: light, fragrant and highly digestible — classic Neapolitan high crust or thin and crispy \"carro di ruota\" style.",
      p2: "Beyond pizza, mAmA is a true Italian restaurant with homemade fresh pasta, traditional dishes, meat specialties and fresh Adriatic seafood. Selected flours, San Marzano DOP tomatoes and Campana buffalo mozzarella: authentic Italy, just steps from the sea.",
      years: "YEARS OF TRADITION",
      h1_title: "Long-rising pizza",
      h1_desc: "Neapolitan style: high soft crust or thin and crispy carro di ruota. Light and digestible.",
      h2_title: "Homemade fresh pasta",
      h2_desc: "Tagliatelle, gnocchi and ravioli made fresh every morning. Meat dishes and Adriatic seafood.",
      h3_title: "No cover charge, open heart",
      h3_desc: "We don't charge for the cover — because real hospitality, at home, is never invoiced.",
    },
    noCoperto: {
      eyebrow: "AT mAmA · ONE LESS THING TO PAY",
      title: "No cover charge.",
      sub: "Because at home hospitality isn't invoiced — and the smile here is always included.",
    },
    menu: {
      eyebrow: "Our menu",
      title: "Flavours of mAmA",
      subtitle: "CUCINA & PIZZA",
      intro: "Long-rising pizza, homemade fresh pasta, seafood and meat specialties. The menu may vary with the season.",
      footer: "Prices in Euro. Please ask the staff about allergies and intolerances.",
      tabs: { antipasti: "Starters", primi: "First Courses", secondi: "Mains", insalate: "Salads", pizze: "Pizzas", dolci: "Desserts", bevande: "Drinks" },
    },
    reviews: {
      eyebrow: "Reviews",
      title: "What they say about us",
      subtitle: "GUESTS · TOURISTS · LOCALS",
      basedOn: "based on over 500 reviews",
      outro: "Enjoyed your experience?",
      leaveLink: "Leave a review →",
    },
    res: {
      eyebrow: "Reservation",
      title: "Book your table",
      desc: "Fill in the form to book. You'll receive a WhatsApp confirmation shortly. For groups of more than 10 people, please contact us directly.",
      info1: "Open 7 days a week · 11:30 – 23:00 non-stop",
      info2: "Tables for 1 – 20 people",
      name: "FULL NAME *",
      phone: "PHONE *",
      email: "EMAIL (optional)",
      date: "DATE *",
      time: "TIME *",
      people: "NUMBER OF PEOPLE *",
      peoplePlaceholder: "How many people?",
      timePlaceholder: "Select time",
      datePlaceholder: "Choose a date",
      notes: "NOTES (allergies, special occasions...)",
      notesPh: "E.g. outdoor table, birthday, intolerances...",
      submit: "Confirm booking",
      submitSub: "By clicking, you'll also be redirected to WhatsApp with pre-filled details.",
      policyTitle: "Important for your booking",
      policyBody: "We allow a maximum delay of 7 minutes. The table is assigned and confirmed only if the full group is present at the reserved time: if even one person is missing, the booking is cancelled. These rules ensure we can respect the other guests who booked and take proper care of everyone in our restaurant.",
      toastErr: "Please fill in all required fields",
      toastOk: "Booking confirmed! See you soon at mAmA.",
      toastFail: "Error sending. Please try again or call us directly.",
      toastFull: "No seats available for that time. Please choose another turn.",
      toastCutoff: "Online bookings for today are closed (after 5:30 PM) so we can prepare the evening service. Please call us directly.",
      groupNote: "For groups over 5 people the booking requires a personal confirmation. The restaurant will contact you shortly to confirm.",
      groupSubmit: "Send group request (6+)",
      cutoffBanner: "Online bookings for today are closed after 5:30 PM so we can prepare the evening service. To book for today please call us:",
      slotFull: "Sold out",
      slotRemaining: "seats left",
      personOne: "person",
      personMany: "people",
    },
    asporto: {
      eyebrow: "TAKE-AWAY",
      title: "Take the taste home.",
      desc: "Our full menu is also available take-away. Order by phone or WhatsApp and pick up in 20 minutes. Online orders coming soon!",
      call: "Call to order",
      whatsapp: "Order on WhatsApp",
      note: "Online orders coming soon.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Come visit us",
      desc: "In the heart of Lignano Sabbiadoro, just a few minutes from the beach. We look forward to welcoming you for an authentic Italian experience.",
      address: "ADDRESS",
      phone: "PHONE",
      email: "EMAIL",
      hours: "HOURS",
      hoursDay: "Every day",
      copyright: "All rights reserved",
    },
    whatsappMsg: "Hi mAmA Cucina e Pizza! I'd like some information.",
    whatsappAsporto: "Hi! I'd like to place a take-away order.",
    whatsappResIntro: "Hi mAmA Cucina e Pizza! I'd like to book a table:",
    whatsappResName: "Name",
    whatsappResPhone: "Phone",
    whatsappResDate: "Date",
    whatsappResTime: "Time",
    whatsappResPeople: "People",
    whatsappResNotes: "Notes",
  },

  de: {
    nav: { home: "Home", menu: "Speisekarte", reviews: "Bewertungen", asporto: "Zum Mitnehmen", contact: "Kontakt", book: "Jetzt reservieren" },
    hero: {
      eyebrow: "Lignano Sabbiadoro",
      tagline: "Lang gereifte Pizza im neapolitanischen Stil — hoher, weicher Rand oder dünn und knusprig „carro di ruota\". Hausgemachte frische Pasta, Adria-Fisch und authentische italienische Küche, nur wenige Schritte vom Meer.",
      bookCta: "Tisch reservieren",
      menuCta: "Speisekarte ansehen",
      open: "7 Tage die Woche geöffnet",
    },
    about: {
      eyebrow: "Unsere Geschichte",
      title: "Die beste Pizzeria",
      subtitle: "IN LIGNANO SABBIADORO",
      p1: "Sie suchen eine Pizzeria in Lignano Sabbiadoro, wo man wirklich gut isst? Dann sind Sie richtig. Bei mAmA ist die Pizza lang gereift: leicht, duftend und sehr bekömmlich — klassisch neapolitanisch mit hohem Rand oder dünn und knusprig als „carro di ruota\".",
      p2: "Neben der Pizza ein echtes italienisches Restaurant mit hausgemachter Pasta, traditionellen Gerichten, Fleisch- und Adria-Fisch-Spezialitäten. Ausgewählte Mehle, San Marzano DOP Tomaten und Büffelmozzarella: authentisches Italien, wenige Schritte vom Meer.",
      years: "JAHRE TRADITION",
      h1_title: "Lang gereifte Pizza",
      h1_desc: "Neapolitanischer Stil: hoher Rand oder dünn und knusprig (carro di ruota). Leicht und bekömmlich.",
      h2_title: "Hausgemachte frische Pasta",
      h2_desc: "Tagliatelle, Gnocchi und Ravioli jeden Morgen frisch. Fleischgerichte und Adria-Fisch.",
      h3_title: "Kein Gedeck, offenes Herz",
      h3_desc: "Bei uns zahlen Sie kein Gedeck — denn zu Hause wird echte Gastfreundschaft nicht berechnet.",
    },
    noCoperto: {
      eyebrow: "BEI mAmA · EINE SACHE WENIGER ZU ZAHLEN",
      title: "Kein Gedeck.",
      sub: "Denn zu Hause wird Gastfreundschaft nicht berechnet — das Lächeln ist immer inklusive.",
    },
    menu: {
      eyebrow: "Unsere Speisekarte",
      title: "Geschmack von mAmA",
      subtitle: "CUCINA & PIZZA",
      intro: "Lang gereifte Pizza, hausgemachte Pasta, Fisch- und Fleischspezialitäten. Das Menü kann saisonal variieren.",
      footer: "Preise in Euro. Bei Allergien und Unverträglichkeiten fragen Sie das Personal.",
      tabs: { antipasti: "Vorspeisen", primi: "Erste Gänge", secondi: "Hauptgerichte", insalate: "Salate", pizze: "Pizzen", dolci: "Desserts", bevande: "Getränke" },
    },
    reviews: {
      eyebrow: "Bewertungen",
      title: "Was man über uns sagt",
      subtitle: "GÄSTE · TOURISTEN · NACHBARN",
      basedOn: "basierend auf über 500 Bewertungen",
      outro: "Hat Ihnen Ihr Besuch gefallen?",
      leaveLink: "Bewertung schreiben →",
    },
    res: {
      eyebrow: "Reservierung",
      title: "Reservieren Sie Ihren Tisch",
      desc: "Füllen Sie das Formular aus. Sie erhalten in Kürze eine WhatsApp-Bestätigung. Für Gruppen über 10 Personen kontaktieren Sie uns bitte direkt.",
      info1: "7 Tage die Woche · 11:30 – 23:00 durchgehend",
      info2: "Tische für 1 – 20 Personen",
      name: "VOR- UND NACHNAME *",
      phone: "TELEFON *",
      email: "E-MAIL (optional)",
      date: "DATUM *",
      time: "UHRZEIT *",
      people: "ANZAHL PERSONEN *",
      peoplePlaceholder: "Wie viele Personen?",
      timePlaceholder: "Uhrzeit wählen",
      datePlaceholder: "Datum wählen",
      notes: "ANMERKUNGEN (Allergien, besondere Anlässe...)",
      notesPh: "Z. B. Tisch im Freien, Geburtstag, Unverträglichkeiten...",
      submit: "Reservierung bestätigen",
      submitSub: "Mit einem Klick werden Sie auch zu WhatsApp mit vorausgefüllten Daten weitergeleitet.",
      policyTitle: "Wichtig für Ihre Reservierung",
      policyBody: "Wir tolerieren eine maximale Verspätung von 7 Minuten. Der Tisch wird nur zugewiesen und bestätigt, wenn die vollständige Gruppe zur reservierten Zeit anwesend ist: fehlt auch nur eine Person, verfällt die Reservierung. Diese Regeln ermöglichen es uns, auch die anderen Gäste zu respektieren, die reserviert haben, und alle unsere Kunden aufmerksam zu betreuen.",
      toastErr: "Bitte füllen Sie alle Pflichtfelder aus",
      toastOk: "Reservierung bestätigt! Bis bald bei mAmA.",
      toastFail: "Sendefehler. Bitte erneut versuchen oder direkt anrufen.",
      toastFull: "Keine Plätze zu dieser Uhrzeit verfügbar. Bitte wählen Sie eine andere.",
      toastCutoff: "Heute sind Online-Reservierungen geschlossen (nach 17:30 Uhr), damit wir den Abendservice bestmöglich vorbereiten können. Bitte rufen Sie direkt an.",
      groupNote: "Für Gruppen über 5 Personen erfordert die Reservierung eine persönliche Bestätigung. Das Restaurant wird sich in Kürze mit Ihnen in Verbindung setzen.",
      groupSubmit: "Gruppenanfrage senden (6+)",
      cutoffBanner: "Heute sind Online-Reservierungen nach 17:30 Uhr geschlossen, damit wir den Abendservice bestmöglich vorbereiten können. Für heute bitte anrufen:",
      slotFull: "Ausgebucht",
      slotRemaining: "Plätze frei",
      personOne: "Person",
      personMany: "Personen",
    },
    asporto: {
      eyebrow: "ZUM MITNEHMEN",
      title: "Nehmen Sie den Geschmack mit nach Hause.",
      desc: "Unsere gesamte Speisekarte ist auch zum Mitnehmen verfügbar. Per Telefon oder WhatsApp bestellen und in 20 Minuten abholen. Online-Bestellungen kommen bald!",
      call: "Zum Bestellen anrufen",
      whatsapp: "Per WhatsApp bestellen",
      note: "Online-Bestellungen bald verfügbar.",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Besuchen Sie uns",
      desc: "Im Herzen von Lignano Sabbiadoro, nur wenige Minuten vom Strand entfernt. Wir freuen uns auf ein authentisches italienisches Erlebnis mit Ihnen.",
      address: "ADRESSE",
      phone: "TELEFON",
      email: "E-MAIL",
      hours: "ÖFFNUNGSZEITEN",
      hoursDay: "Täglich",
      copyright: "Alle Rechte vorbehalten",
    },
    whatsappMsg: "Hallo mAmA Cucina e Pizza! Ich hätte gerne einige Informationen.",
    whatsappAsporto: "Hallo! Ich möchte eine Bestellung zum Mitnehmen aufgeben.",
    whatsappResIntro: "Hallo mAmA Cucina e Pizza! Ich möchte einen Tisch reservieren:",
    whatsappResName: "Name",
    whatsappResPhone: "Telefon",
    whatsappResDate: "Datum",
    whatsappResTime: "Uhrzeit",
    whatsappResPeople: "Personen",
    whatsappResNotes: "Anmerkungen",
  },

  pt: {
    nav: { home: "Início", menu: "Menu", reviews: "Avaliações", asporto: "Take-away", contact: "Contato", book: "Reservar agora" },
    hero: {
      eyebrow: "Lignano Sabbiadoro",
      tagline: "Pizza de longa fermentação em estilo napolitano — borda alta macia ou fina e crocante \"carro di ruota\". Massa fresca feita em casa, peixe do Adriático e autêntica cozinha italiana, a poucos passos do mar.",
      bookCta: "Reservar uma mesa",
      menuCta: "Ver o menu",
      open: "Abertos 7 dias por semana",
    },
    about: {
      eyebrow: "A nossa história",
      title: "A melhor pizzaria",
      subtitle: "EM LIGNANO SABBIADORO",
      p1: "Procura uma pizzaria em Lignano Sabbiadoro onde realmente se come bem? Está no sítio certo. Na mAmA a pizza é de longa fermentação: leve, aromática e muito digestiva — estilo napolitano clássico de borda alta ou fina e crocante \"carro di ruota\".",
      p2: "Além da pizza, um verdadeiro restaurante italiano com massa fresca feita em casa, pratos tradicionais, especialidades de carne e peixe do Adriático. Farinhas selecionadas, tomate San Marzano DOP e mozzarella de búfala: a Itália autêntica a poucos passos do mar.",
      years: "ANOS DE TRADIÇÃO",
      h1_title: "Pizza de longa fermentação",
      h1_desc: "Estilo napolitano: borda alta macia ou fina e crocante carro di ruota. Leve e digestiva.",
      h2_title: "Massa fresca feita em casa",
      h2_desc: "Tagliatelle, gnocchi e ravioli preparados todas as manhãs. Pratos de carne e peixe do Adriático.",
      h3_title: "Sem couvert, coração aberto",
      h3_desc: "Aqui não se paga couvert — porque em casa a hospitalidade não se cobra.",
    },
    noCoperto: {
      eyebrow: "NA mAmA · UMA COISA A MENOS PARA PAGAR",
      title: "Sem couvert.",
      sub: "Porque em casa a hospitalidade não se cobra — e o sorriso, aqui, está sempre incluído.",
    },
    menu: {
      eyebrow: "O nosso menu",
      title: "Sabores da mAmA",
      subtitle: "CUCINA & PIZZA",
      intro: "Pizza de longa fermentação, massa fresca feita em casa, especialidades de mar e carne. O menu pode variar conforme a estação.",
      footer: "Preços em Euro. Para alergias e intolerâncias pergunte ao pessoal.",
      tabs: { antipasti: "Entradas", primi: "Primeiros", secondi: "Principais", insalate: "Saladas", pizze: "Pizzas", dolci: "Sobremesas", bevande: "Bebidas" },
    },
    reviews: {
      eyebrow: "Avaliações",
      title: "O que dizem de nós",
      subtitle: "HÓSPEDES · TURISTAS · VIZINHOS",
      basedOn: "com base em mais de 500 avaliações",
      outro: "Gostou da sua experiência?",
      leaveLink: "Deixar uma avaliação →",
    },
    res: {
      eyebrow: "Reserva",
      title: "Reserve a sua mesa",
      desc: "Preencha o formulário para reservar. Receberá uma confirmação via WhatsApp em breve. Para grupos com mais de 10 pessoas, contate-nos diretamente.",
      info1: "Abertos 7 dias por semana · 11:30 – 23:00 non-stop",
      info2: "Mesas para 1 – 20 pessoas",
      name: "NOME E APELIDO *",
      phone: "TELEFONE *",
      email: "EMAIL (opcional)",
      date: "DATA *",
      time: "HORA *",
      people: "NÚMERO DE PESSOAS *",
      peoplePlaceholder: "Quantas pessoas?",
      timePlaceholder: "Selecione a hora",
      datePlaceholder: "Escolha uma data",
      notes: "NOTAS (alergias, ocasião especial...)",
      notesPh: "Ex. mesa ao ar livre, aniversário, intolerâncias...",
      submit: "Confirmar reserva",
      submitSub: "Ao clicar, será redirecionado também para o WhatsApp com os dados pré-preenchidos.",
      policyTitle: "Importante para a sua reserva",
      policyBody: "Toleramos um atraso máximo de 7 minutos. A mesa é atribuída e confirmada apenas se o grupo estiver completo à hora reservada: se faltar mesmo uma só pessoa, a reserva é anulada. Estas regras permitem-nos respeitar os outros clientes que reservaram e cuidar com atenção de todos os nossos hóspedes.",
      toastErr: "Preencha todos os campos obrigatórios",
      toastOk: "Reserva confirmada! Até já no mAmA.",
      toastFail: "Erro no envio. Tente novamente ou ligue-nos diretamente.",
      toastFull: "Lugares esgotados para esse horário. Escolha outro turno.",
      toastCutoff: "As reservas online de hoje estão fechadas (após as 17:30) para prepararmos o serviço da noite. Ligue-nos diretamente.",
      groupNote: "Para grupos com mais de 5 pessoas a reserva requer uma confirmação pessoal. O restaurante entrará em contato em breve.",
      groupSubmit: "Enviar pedido de grupo (6+)",
      cutoffBanner: "As reservas online de hoje estão fechadas após as 17:30 para prepararmos o serviço da noite. Para reservar para hoje ligue-nos:",
      slotFull: "Esgotado",
      slotRemaining: "lugares disponíveis",
      personOne: "pessoa",
      personMany: "pessoas",
    },
    asporto: {
      eyebrow: "TAKE-AWAY",
      title: "Leve o sabor para casa.",
      desc: "Todo o nosso menu também está disponível para take-away. Peça por telefone ou WhatsApp e levante em 20 minutos. Pedidos online em breve!",
      call: "Ligue para encomendar",
      whatsapp: "Pedir por WhatsApp",
      note: "Pedidos online em breve.",
    },
    contact: {
      eyebrow: "Contato",
      title: "Venha visitar-nos",
      desc: "No coração de Lignano Sabbiadoro, a poucos minutos da praia. Esperamos por si para uma experiência italiana autêntica.",
      address: "MORADA",
      phone: "TELEFONE",
      email: "EMAIL",
      hours: "HORÁRIO",
      hoursDay: "Todos os dias",
      copyright: "Todos os direitos reservados",
    },
    whatsappMsg: "Olá mAmA Cucina e Pizza! Queria algumas informações.",
    whatsappAsporto: "Olá! Queria fazer um pedido take-away.",
    whatsappResIntro: "Olá mAmA Cucina e Pizza! Queria reservar uma mesa:",
    whatsappResName: "Nome",
    whatsappResPhone: "Telefone",
    whatsappResDate: "Data",
    whatsappResTime: "Hora",
    whatsappResPeople: "Pessoas",
    whatsappResNotes: "Notas",
  },

  hu: {
    nav: { home: "Főoldal", menu: "Étlap", reviews: "Vélemények", asporto: "Elvitel", contact: "Kapcsolat", book: "Foglalás" },
    hero: {
      eyebrow: "Lignano Sabbiadoro",
      tagline: "Hosszan érlelt nápolyi stílusú pizza — magas, puha szélű vagy vékony és ropogós „carro di ruota\". Házi friss tészta, adriai halak és eredeti olasz konyha, pár lépésre a tengertől.",
      bookCta: "Asztalfoglalás",
      menuCta: "Étlap megtekintése",
      open: "A hét minden napján nyitva",
    },
    about: {
      eyebrow: "A történetünk",
      title: "A legjobb pizzéria",
      subtitle: "LIGNANO SABBIADORÓBAN",
      p1: "Pizzériát keresel Lignano Sabbiadoróban, ahol tényleg jól lehet enni? Jó helyen jársz. A mAmA-nál a pizza hosszan érlelt: könnyű, illatos és könnyen emészthető — klasszikus nápolyi magas szélű, vagy vékony és ropogós „carro di ruota\" stílusban.",
      p2: "A pizza mellett igazi olasz étterem házi friss tésztákkal, hagyományos fogásokkal, hús- és adriai hal specialitásokkal. Válogatott lisztek, San Marzano DOP paradicsom és bivalymozzarella: az eredeti Olaszország, pár lépésre a tengertől.",
      years: "ÉV HAGYOMÁNY",
      h1_title: "Hosszan érlelt pizza",
      h1_desc: "Nápolyi stílus: magas puha szél vagy vékony és ropogós carro di ruota. Könnyű és emészthető.",
      h2_title: "Házi friss tészta",
      h2_desc: "Tagliatelle, gnocchi és ravioli minden reggel frissen készítve. Húsételek és adriai halak.",
      h3_title: "Nincs kuvert, nyitott szív",
      h3_desc: "Nálunk nincs kuvert — mert otthon a vendégszeretetet nem számolják fel.",
    },
    noCoperto: {
      eyebrow: "A mAmA-NÁL · EGGYEL KEVESEBB DOLOG, AMIÉRT FIZETNI KELL",
      title: "Nincs kuvert.",
      sub: "Mert otthon a vendégszeretetet nem számolják fel — a mosoly pedig mindig benne van.",
    },
    menu: {
      eyebrow: "Étlapunk",
      title: "A mAmA ízei",
      subtitle: "CUCINA & PIZZA",
      intro: "Hosszan érlelt pizza, házi friss tészta, tenger és hús specialitások. Az étlap szezonálisan változhat.",
      footer: "Az árak euróban vannak feltüntetve. Allergia vagy intolerancia esetén kérdezze a személyzetet.",
      tabs: { antipasti: "Előételek", primi: "Első fogások", secondi: "Főételek", insalate: "Saláták", pizze: "Pizzák", dolci: "Desszertek", bevande: "Italok" },
    },
    reviews: {
      eyebrow: "Vélemények",
      title: "Mit mondanak rólunk",
      subtitle: "VENDÉGEK · TURISTÁK · SZOMSZÉDOK",
      basedOn: "több mint 500 vélemény alapján",
      outro: "Tetszett a látogatás?",
      leaveLink: "Hagyj véleményt →",
    },
    res: {
      eyebrow: "Foglalás",
      title: "Foglald le az asztalod",
      desc: "Töltsd ki az űrlapot. Hamarosan megerősítést kapsz WhatsApp-on. 10 főnél nagyobb csoport esetén lépj velünk közvetlenül kapcsolatba.",
      info1: "A hét minden napján · 11:30 – 23:00 folyamatosan",
      info2: "1 – 20 fős asztalok",
      name: "TELJES NÉV *",
      phone: "TELEFON *",
      email: "EMAIL (nem kötelező)",
      date: "DÁTUM *",
      time: "IDŐPONT *",
      people: "SZEMÉLYEK SZÁMA *",
      peoplePlaceholder: "Hány fő?",
      timePlaceholder: "Válassz időpontot",
      datePlaceholder: "Válassz dátumot",
      notes: "MEGJEGYZÉSEK (allergia, különleges alkalom...)",
      notesPh: "Pl. kinti asztal, születésnap, intolerancia...",
      submit: "Foglalás megerősítése",
      submitSub: "Kattintás után a WhatsApp is megnyílik előre kitöltött adatokkal.",
      policyTitle: "Fontos a foglaláshoz",
      policyBody: "Maximum 7 perc késést tolerálunk. Az asztalt csak akkor foglaljuk le és erősítjük meg, ha a teljes társaság a lefoglalt időpontban jelen van: ha akár egy fő is hiányzik, a foglalás érvényét veszti. Ezek a szabályok lehetővé teszik számunkra, hogy tiszteletben tartsuk a többi vendégünket, akik szintén foglaltak, és figyelmesen kiszolgáljuk minden ügyfelünket.",
      toastErr: "Töltsd ki az összes kötelező mezőt",
      toastOk: "Foglalás megerősítve! Hamarosan találkozunk a mAmA-ban.",
      toastFail: "Hiba a küldés során. Próbáld újra vagy hívj minket közvetlenül.",
      toastFull: "Nincs szabad hely ebben az időpontban. Kérjük, válassz másikat.",
      toastCutoff: "A mai napra az online foglalás lezárult (17:30 után), hogy zavartalanul készülhessünk az esti szolgálatra. Kérjük, hívj minket közvetlenül.",
      groupNote: "5 főnél nagyobb csoport esetén a foglalás személyes megerősítést igényel. Az étterem hamarosan felveszi veled a kapcsolatot.",
      groupSubmit: "Csoportos kérés küldése (6+)",
      cutoffBanner: "A mai napra az online foglalás 17:30 után lezárult, hogy zavartalanul készülhessünk az esti szolgálatra. Mai foglaláshoz kérjük, hívj minket:",
      slotFull: "Betelt",
      slotRemaining: "hely szabad",
      personOne: "fő",
      personMany: "fő",
    },
    asporto: {
      eyebrow: "ELVITEL",
      title: "Vidd haza az ízeket.",
      desc: "A teljes étlapunk elvitelre is elérhető. Rendelj telefonon vagy WhatsApp-on, és 20 percen belül átveheted. Online rendelés hamarosan!",
      call: "Hívj a rendeléshez",
      whatsapp: "Rendelj WhatsApp-on",
      note: "Online rendelés hamarosan.",
    },
    contact: {
      eyebrow: "Kapcsolat",
      title: "Gyere el hozzánk",
      desc: "Lignano Sabbiadoro szívében, pár percre a strandtól. Várunk egy eredeti olasz élményre.",
      address: "CÍM",
      phone: "TELEFON",
      email: "EMAIL",
      hours: "NYITVATARTÁS",
      hoursDay: "Minden nap",
      copyright: "Minden jog fenntartva",
    },
    whatsappMsg: "Szia mAmA Cucina e Pizza! Szeretnék információt kérni.",
    whatsappAsporto: "Szia! Elvitelre szeretnék rendelni.",
    whatsappResIntro: "Szia mAmA Cucina e Pizza! Szeretnék asztalt foglalni:",
    whatsappResName: "Név",
    whatsappResPhone: "Telefon",
    whatsappResDate: "Dátum",
    whatsappResTime: "Időpont",
    whatsappResPeople: "Fő",
    whatsappResNotes: "Megjegyzések",
  },
};

const LangContext = createContext({ lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k });

const getByPath = (obj, path) => path.split(".").reduce((a, k) => (a && a[k] !== undefined ? a[k] : undefined), obj);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(DEFAULT_LANG);

  useEffect(() => {
    const stored = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
    if (stored && LANGS.includes(stored)) {
      setLangState(stored);
      document.documentElement.lang = stored;
      return;
    }
    const browser = (navigator.language || "it").slice(0, 2).toLowerCase();
    const picked = LANGS.includes(browser) ? browser : DEFAULT_LANG;
    setLangState(picked);
    document.documentElement.lang = picked;
  }, []);

  const setLang = (l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    document.documentElement.lang = l;
    try { window.localStorage.setItem(STORAGE_KEY, l); } catch {}
  };

  const t = (path) => {
    const v = getByPath(dict[lang], path);
    if (v !== undefined) return v;
    return getByPath(dict[DEFAULT_LANG], path) ?? path;
  };

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useT = () => useContext(LangContext);
export const LANG_LIST = LANGS;
export const LANG_LABELS = {
  it: { flag: "🇮🇹", name: "Italiano" },
  en: { flag: "🇬🇧", name: "English" },
  de: { flag: "🇩🇪", name: "Deutsch" },
  pt: { flag: "🇵🇹", name: "Português" },
  hu: { flag: "🇭🇺", name: "Magyar" },
};
